import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ProductLineHeaderStyled = styled.header`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.neutral[300]};
  padding-bottom: 1.6rem;
  flex-direction: column;
`;

export const ProductLineTitleStyled = styled.h3`
  font-size: 2.4rem;
  line-height: 3.2rem;
  font-weight: 700;
  display: flex;
  align-items: middle;
  margin: 0 0 0.4rem;
  color: ${colors.neutral[900]};
`;

export const TitleTextStyled = styled.span`
  margin-left: 0.8rem;
`;
